import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IExamAnswerRequest } from '@/Module/Exam/Model/ApiModel';
import type { IExam, IExamQuestion, IExamUserExamAnswer } from '@/Module/Exam/Model/DataModel';
import { ExamCookieService, ExamService } from '@/Module/Exam/Service';

interface IProps extends IExamAnswerRequest {
  examId: IExam['id'];
  questionId: IExamQuestion['id'];
}

export const answerExamQuestionAction = createAsyncThunk<IExamUserExamAnswer, IProps>(
  'exam/answerQuestion',
  async ({ examId, questionId, ...req }, { signal }) => {
    const examAccessToken = ExamCookieService.getAccessToken();
    return ExamService.answerExamQuestion(examId, questionId, examAccessToken, req, signal).then(({ data }) => data);
  },
);
